/* eslint-disable */
<template>
  <div class="container pt-5 connect">
    <div class="row">
      <div class="col-md-6 mid-row text-center">
        <h4>Conect With Us</h4>

        <p>Social media are essential for catching up and sharing great moments that you have experienced.</p>
        <div class="contact-social-icon m-4">
          <a href="https://www.facebook.com/">
            <i class="fa fa-facebook mr-3"></i>
          </a>
          <a href="https://instagram.com">
            <i class="fa fa-instagram mr-3"></i>
          </a>
          <a href="https://twitter.com">
            <i class="fa fa-twitter mr-3"></i>
          </a>
        </div>
      </div>
      <div class="col-md-6 contact text-center">
        <h4>Contact Us</h4>
        <p>
          <i class="fa fa-map-marker mr-2"></i>Visit Us:
          <span class="number">64 Adekunle Street, Yaba Lagos, Nigeria</span>
        </p>
        <p>
          <i class="fa fa-phone mr-2"></i>Call Us:
          <span class="number">+2348073385431</span>
        </p>
        <p>
          <i class="fa fa-envelope-open mr-2"></i>Email Us:
          <span class="number">info@mbclothing.com</span>
        </p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "ContactGrid"
};
</script>

<style></style>
